import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStoreCtx } from "../../store";
import { Subscription } from "../../util/promo";
// import { ChooseSubscription } from "./choose-subscription/choose-subscriptioon";
import { PaymentConfirm } from "./payment-confirm/payment-confirm";
import { PaymentInit } from "./payment-init/payment-init";

export enum PaymentStep {
	Choose, // выбор подписки
    Init,
    Phone,
    Card,
    Error,
    Success
}

export const SubscriptionOffer = observer(() => {
    const httpService = useStoreCtx().appStore;

    const selectedSubscription: Subscription = httpService.selectedSubscription

	useEffect(() => {
        httpService.selectedSubscription = httpService.subscriptions.find(
            (sub) => sub.promotion.timeToLiveValue?.toString() === window.sessionStorage.getItem("subscription_period")
        ) ?? httpService.subscriptions[0]
    }, [])

    const [step, setStep] = useState<PaymentStep>(PaymentStep.Init);

    function isSelectedPaymentMethod() {
        return [PaymentStep.Phone, PaymentStep.Card].indexOf(step) !== -1
    }

    const navigate = useNavigate();

    // Чтобы при нажатии браузерной кнопки "назад" - перекидывало на главную
    useEffect(() => {
        window.history.pushState(null, document.title)

        const handlePopEvent = (event: PopStateEvent) => navigate('/');
        window.addEventListener('popstate', handlePopEvent)

        return () => {
            window.removeEventListener('popstate', handlePopEvent);
        }
    }, []);

	// Редирект на главную страницу после перезагрузки страницы
	useEffect(() => {
		const handleBeforeUnload = (e: BeforeUnloadEvent) => {
			localStorage.setItem('wasReloaded', 'true');
		};

		const handleLoad = () => {
			const wasReloaded = localStorage.getItem('wasReloaded');
			if (wasReloaded) {
				localStorage.removeItem('wasReloaded');
				navigate({ pathname: '/' });
			}
		};

		window.addEventListener('beforeunload', handleBeforeUnload);
		window.addEventListener('load', handleLoad);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
			window.removeEventListener('load', handleLoad);
		};
	}, []);

    return (
        <div style={{
            background: '#090B3F',
            height: '100vh',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
        }}>

			{/* Так как ТВХ-продукт один - выбор подписки не нужен */}
			{/* {step === PaymentStep.Choose && (
				<ChooseSubscription 
					onNext={() => setStep(PaymentStep.Init)}
				/>
			)} */}

            {step === PaymentStep.Init && (
                <PaymentInit 
                    subscription={selectedSubscription}
                    onNext={(event) => setStep(event)} 
                />
            )}
         
            {isSelectedPaymentMethod() && (
                <PaymentConfirm
                    paymentMethod={step}
                    subscription={selectedSubscription}
                    onNext={(event) => setStep(event)} 
                />
            )}
       </div>
    )
})